import { render, staticRenderFns } from "./AbsencesPage.vue?vue&type=template&id=421b4afa&scoped=true&lang=pug&"
import script from "./AbsencesPage.vue?vue&type=script&lang=ts&"
export * from "./AbsencesPage.vue?vue&type=script&lang=ts&"
import style0 from "./AbsencesPage.vue?vue&type=style&index=0&id=421b4afa&lang=stylus&scoped=true&"
import style1 from "./AbsencesPage.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421b4afa",
  null
  
)

export default component.exports